import React from 'react';

import './PaymentTrendsScoreboard.css'

export default function PaymentTrendsScoreboard(props) {

    function getTotalPayments() {
        let totalPayments = 0;
        if (props.data) {
            props.data.forEach(item => {
                switch (item[0]) {
                    case 'Check Payments':
                        totalPayments += item[1];
                        break;
                    case 'Deposit to Debit Card Payments':
                        totalPayments += item[1];
                        break;
                    case 'Virtual Credit Card Payments':
                        totalPayments += item[1];
                        break;
                    case 'Direct Deposit Payments':
                        totalPayments += item[1];
                        break;
                    case 'eCheck Payments':
                        totalPayments += item[1];
                        break;
                    case 'Lienholder Payments':
                        totalPayments += item[1];
                        break;
                    default:
                        // Unknown Types should be ignored
                        break;
                }
            });
        }

        return totalPayments;
    }

    function getTypeInfo(name) {
        switch (name) {
            case 'Check Payments':
                return ["efup-scoreboard-blue-dot", "efup-scoreboard-check-payments"]
            case 'Deposit to Debit Card Payments':
                return ["efup-scoreboard-light-green-dot", "efup-scoreboard-direct-to-debit-payments"]
            case 'Virtual Credit Card Payments':
                return ["efup-scoreboard-red-dot", "efup-scoreboard-virtual-card-payments"]
            case 'Direct Deposit Payments':
                return ["efup-scoreboard-yellow-dot", "efup-scoreboard-direct-deposit-payments"]
            case 'eCheck Payments':
                return ["efup-scoreboard-grey-dot", "efup-scoreboard-echeck-payments"]
            case 'Lienholder Payments':
                return ["efup-scoreboard-dark-green-dot", "efup-scoreboard-lienholder-payments"]
            default:
                // Unknown Types should be ignored
                return null;
        }
    }

    return (
        <div className="efup-payment-trends-scoreboard">
            <div className='efup-scoreboard-total-payments cb-font-poppins' data-testid="efup-scoreboard-total-payments">{getTotalPayments()} total payments</div>
            {props.data && props.data.map(item => {
                const specificTypes = getTypeInfo(item[0]);
                if (specificTypes) {
                    return <div className="cb-font-poppins efup-scoreboard-content-wrapper" key={`${specificTypes[1]}-${item[1]}`}>
                        <span className={`efup-scoreboard-content-dot ${specificTypes[0]}`} data-testid={`${specificTypes[1]}-dot`} />
                        <div className="efup-scoreboard-content-number" data-testid={`${specificTypes[1]}-number`}>{item[1]}</div>
                        {specificTypes[1] === "efup-scoreboard-virtual-card-payments" ?
                            <div className="efup-scoreboard-content-name" data-testid={`${specificTypes[1]}-name`}>Virtual Card Payments</div> :
                            <div className="efup-scoreboard-content-name" data-testid={`${specificTypes[1]}-name`}>{item[0]}</div>}
                    </div>;
                }
                return <React.Fragment />
            })}
        </div>
    )
}